import counselors from './counselors'
import uiState from './uiState'
import auth from './auth'
import trial from './trial'
import item from './item'
import payment from './payment'
import entry from './entry'
import account from './account'
import commentView from './commentView'
import dialogs from './dialogs'
import recommend from './recommend'
import utilities from "./utilities";

export default {
  counselors,
  uiState,
  auth,
  trial,
  item,
  payment,
  entry,
  account,
  commentView,
  dialogs,
  recommend,
  utilities,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/index.js